import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { styled } from '../../../foundation';
import { RcTextField } from '../../Forms/TextField';
import { clearBtnInactiveStyle } from '../../Forms/TextField/styles';
import { RcDownshiftInputClasses } from '../utils';
var _StyledTextField = forwardRef(function (_a, ref) {
    var hasTags = _a.hasTags, renderInput = _a.renderInput, rest = __rest(_a, ["hasTags", "renderInput"]);
    if (renderInput) {
        var child = renderInput(__assign(__assign({}, rest), { ref: ref }));
        return child;
    }
    return React.createElement(RcTextField, __assign({ ref: ref }, rest));
});
export var StyledTextField = styled(_StyledTextField)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .", " {\n    flex: 1;\n    min-width: 30px;\n  }\n\n  ", "\n"], ["\n  .", " {\n    flex: 1;\n    min-width: 30px;\n  }\n\n  ", "\n"])), RcDownshiftInputClasses.input, function (_a) {
    var hasTags = _a.hasTags;
    return hasTags && clearBtnInactiveStyle;
});
var templateObject_1;
